import reportsService from '@/services/reports.service'

export default {


  // 👤 Get daily revenue
  async getDailyRevenue({ commit }, params) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_DAILY_REVENUE_MESSAGE', null)
    try {
      const report = await reportsService.getDailyRevenue(params)
      commit('SET_REPORT', report)
     if (report.data.file_url) {
        commit('SET_DAILY_REVENUE_MESSAGE',  'Report downloaded successfully')
      } else {
        commit('SET_DAILY_REVENUE_ERROR',  {message:'There is no data available to generate this report.'})
      }
      return report
    } catch (err) {
      commit('SET_DAILY_REVENUE_ERROR', err.response?.data?.message || 'Failed to fetch report')
    } finally {
      commit('SET_LOADING', false)
    }
  },



  async getCogsReport({ commit }, params) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_COGS_MESSAGE', null)
    try {
      const report = await reportsService.getCogsReport(params)
      commit('SET_REPORT', report)
      if (report.data.file_url) {
        commit('SET_COGS_MESSAGE',  'Report downloaded successfully')
      } else {
        commit('SET_COGS_ERROR',  {message:'There is no data available to generate this report.'})
      }
      return report
    } catch (err) {
      commit('SET_COGS_ERROR', err.response?.data?.message || 'Failed to fetch report')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getIncomingInvoicesReport({ commit }, params) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_INCOMING_INVOICES_MESSAGE', null)
    try {
      const report = await reportsService.getIncomingInvoicesReport(params)
      commit('SET_REPORT', report)
      if (report.data.file_url) {
        commit('SET_INCOMING_INVOICES_MESSAGE',  'Report downloaded successfully')
      } else {
        commit('SET_INCOMING_INVOICES_ERROR',  {message:'There is no data available to generate this report.'})
      }
      return report
    } catch (err) {
      commit('SET_INCOMING_INVOICES_ERROR', err || 'Failed to fetch report')
      throw err
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearMessage({ commit }) {
    commit('SET_MESSAGE', null)
    commit('SET_ERROR', null)
    commit('SET_DAILY_REVENUE_ERROR', null)
    commit('SET_COGS_ERROR', null)
    commit('SET_INCOMING_INVOICES_ERROR', null)
  },
  clearDailyRevenueMessage({ commit }) {
    commit('SET_DAILY_REVENUE_ERROR', null)
    commit('SET_DAILY_REVENUE_MESSAGE', null)
  },
  clearCogsMessage({ commit }) {
    commit('SET_COGS_ERROR', null)
    commit('SET_COGS_MESSAGE', null)
  },
  clearIncomingInvoicesMessage({ commit }) {
    commit('SET_INCOMING_INVOICES_ERROR', null)
    commit('SET_INCOMING_INVOICES_MESSAGE', null)
  },
}